import { DrawerIds } from "./drawer-ids";
import { DrawerModalAction } from "./drawer-modal-action";
import { DrawerModalRepositoryInterface } from "./drawer-modal-repository-interface";
import { DrawerModalRepository } from "./drawer-modal-repository";

export class DrawerService {
  private drawerModalRepository: DrawerModalRepositoryInterface;

  constructor(drawerModalRepository = new DrawerModalRepository()) {
    this.setDrawerModalRepository(drawerModalRepository);
  }

  getDrawerModalRepository() {
    return this.drawerModalRepository;
  }

  setDrawerModalRepository(
    drawerModalRepository: DrawerModalRepositoryInterface,
  ) {
    this.drawerModalRepository = drawerModalRepository;
  }

  closeTileDrawerModal(drawerId: DrawerIds) {
    this.getDrawerModalRepository().updateModalsCloseDrawerModal(
      new DrawerModalAction(false, drawerId),
    );
  }
}
